import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import thunk from 'redux-thunk'

import ctgr from './reducers/categories'
// import itms from './reducers/items'
import loct from './reducers/locations'
import exst from './reducers/existencesold'
import deal from './reducers/dealers'
import clie from './reducers/clients'
import warh from './reducers/warehouses'
import trfs from './reducers/transfers'
import bank from './reducers/banks'
import paym from './reducers/payment_methods'
import curr from './reducers/currencies'
import bcnt from './reducers/bank_accounts_old'
import auth from './reducers/authentication'
import exst1 from './reducers/existence'
import mvts from './reducers/movements'
import slls from './reducers/sells'
import psls from './reducers/pending_sells'
import acct from './reducers/accounts'
import prch from './reducers/purchases'
import pcho from './reducers/purchase_orders'
import dlvn from './reducers/delivery_notes'
import spdlvn from './reducers/sales_pending_delivery_notes'
import sdlvn from './reducers/sales_historic_delivery_notes'
import sellers from './reducers/sellers'
import sllsByClt from './reducers/clients_by_seller'
import dlvNtByClt from './reducers/delivery_notes_by_seller'
import rates from './reducers/rates'

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
  combineReducers({
    auth,
    ctgr,
    // itms,
    loct,
    warh,
    exst,
    exst1,
    deal,
    clie,
    trfs,
    bank,
    paym,
    curr,
    bcnt,
    mvts,
    slls,
    psls,
    acct,
    prch,
    pcho,
    dlvn,
    spdlvn,
    sdlvn,
    sellers,
    sllsByClt,
    dlvNtByClt,
    rates
  }),
  composeEnhancers(applyMiddleware(thunk))
)

export default store

export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
